import { DocumentModel } from './document.model';
import { DocumentCommonSettingModel } from './document-common-setting.model';
import { IPublicationSetting, PublicationSettingModel } from '@fi-shared/models';

export class DocumentSettingModel {
    CommentSettingType;
    IsNews: boolean;
    IsShared: boolean;
    PublicationType;
    PublicationActionType;

    static updateDocumentFromSetting(document: DocumentModel, setting: DocumentSettingModel) {
        document.DocumentSetting.CommentSettingType = setting.CommentSettingType;
        document.DocumentSetting.IsNews = setting.IsNews;
        document.PublicationSetting.IsShared = setting.IsShared;
        document.PublicationSetting.PublicationType = setting.PublicationType;
        document.PublicationSetting.PublicationActionType = setting.PublicationActionType;
    }

    static createFromDocument(
        commonSetting: DocumentCommonSettingModel,
        publicationSetting: IPublicationSetting,
    ): DocumentSettingModel {
        const setting = new DocumentSettingModel();
        setting.CommentSettingType = commonSetting.CommentSettingType;
        setting.IsNews = commonSetting.IsNews;
        setting.IsShared = publicationSetting.IsShared;
        setting.PublicationType = publicationSetting.PublicationType;
        setting.PublicationActionType = publicationSetting.PublicationActionType;
        return setting;
    }
}
